import React, { useContext, useState, useMemo } from 'react'

import { useLocation } from "react-router-dom"

import { ScreenContext } from '..';

import Information from './Information';
import SendMessage from './SendMessage';
import AddClient from './AddClient';
import ImportClients from './ImportClients';
import NotificationFilter from './NotificationFilter';
import CreateCampaign from './CreateCampaign';
import { getSession } from "../../../auth";

const TabButtons = () => {

    const location = useLocation()

    const { isSmallScreen, selectedTab, settings, permissions, selectedView } = useContext(ScreenContext)

    const urlParams = useMemo(() => new URLSearchParams(location.search), [location.search])
    const selectedTabParam = urlParams.get("selectedTab")
    const subTab = urlParams.get("subTab")

    const canCreateCampaigns = (permissions.isAdmin || permissions.isSupervisor) ? true : getSession().profile.change_campaigns

    const user = getSession()

    if (selectedTab === "clients" && selectedView === "table")
        return <SendMessage/>
    if (selectedTab === "campaigns" && selectedTabParam === "notifications" && ! isSmallScreen)
        return <NotificationFilter />
    if (selectedTab === "campaigns" && selectedTabParam === "campaigns" && subTab !== "templates" && ! isSmallScreen && canCreateCampaigns)
        return <CreateCampaign />

    return <></>
}

export default TabButtons
